import { render, staticRenderFns } from "./signDocumentsPage.vue?vue&type=template&id=644edba6&scoped=true&"
import script from "./signDocumentsPage.vue?vue&type=script&lang=ts&"
export * from "./signDocumentsPage.vue?vue&type=script&lang=ts&"
import style0 from "./signDocumentsPage.vue?vue&type=style&index=0&id=644edba6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644edba6",
  null
  
)

export default component.exports